"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// @ts-ignore
var authStore_1 = require("$ice/authStore");
var wrapperComponentFn = function (authConfig) { return function (PageComponent) {
    var _a = PageComponent.pageConfig, pageConfig = _a === void 0 ? {} : _a;
    var AuthWrapperedComponent = function (props) {
        var auth = props.auth, rest = __rest(props, ["auth"]);
        var authState = auth[0];
        var pageConfigAuth = pageConfig.auth;
        if (pageConfigAuth && !Array.isArray(pageConfigAuth)) {
            throw new Error('pageConfig.auth must be an array');
        }
        var hasAuth = Array.isArray(pageConfigAuth) && pageConfigAuth.length
            ? Object.keys(authState).filter(function (item) { return pageConfigAuth.includes(item) ? authState[item] : false; }).length
            : true;
        if (!hasAuth) {
            if (authConfig.NoAuthFallback) {
                if (typeof authConfig.NoAuthFallback === 'function') {
                    return React.createElement(authConfig.NoAuthFallback, null);
                }
                return authConfig.NoAuthFallback;
            }
            return null;
        }
        return React.createElement(PageComponent, __assign({}, rest));
    };
    return authStore_1.default.withModel('auth')(AuthWrapperedComponent);
}; };
exports.default = (function (_a) {
    var context = _a.context, appConfig = _a.appConfig, addProvider = _a.addProvider, wrapperRouteComponent = _a.wrapperRouteComponent;
    var initialData = context && context.initialData ? context.initialData : {};
    var initialAuth = initialData.auth || {};
    var authConfig = appConfig.auth || {};
    var AuthStoreProvider = function (_a) {
        var children = _a.children;
        return (React.createElement(authStore_1.default.Provider, { initialStates: { auth: initialAuth } }, children));
    };
    addProvider(AuthStoreProvider);
    wrapperRouteComponent(wrapperComponentFn(authConfig));
});
